import { create } from 'zustand';

export type ToastType = 'success' | 'error' | 'info';

export type Toast = {
  id: string;
  title?: string;
  description?: string;
  type: ToastType;
  duration?: number;
};

interface ToastState {
  toasts: Toast[];
  addToast: (toast: Omit<Toast, 'id'> & { id?: string }) => string;
  removeToast: (id: string) => void;
}

const generateId = () => `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;

export const useToastStore = create<ToastState>((set) => ({
  toasts: [],
  addToast: ({ id, ...toast }) => {
    const toastWithId: Toast = {
      id: id || generateId(),
      ...toast,
    };
    set((state) => ({
      toasts: [...state.toasts, toastWithId],
    }));
    return toastWithId.id;
  },
  removeToast: (toastId) =>
    set((state) => ({
      toasts: state.toasts.filter((toast) => toast.id !== toastId),
    })),
}));
